let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cq8H8")).then(() => parcelRequire('h0bmE'));